export default function automatedDiscountLabelArgs(item, keyPrefix) {
  const triggerName = item?.automatedDiscountTriggerName;

  return triggerName
    ? [`${keyPrefix}.named`, { triggerName }]
    : [`${keyPrefix}._default`];
}
